// BiologyPlaceholder.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./BiologyPlaceholder.css";

const BiologyPlaceholder = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/tutorials");
  };

  return (
    <div className="biology-placeholder-container">
      <h1 className="placeholder-heading">Biology Tutorials – Coming Soon</h1>
        <p className="placeholder-text">
        At PrrepX Pathshala, we are committed to delivering the highest quality educational content.  
        We have not yet started creating the Biology tutorials for Class 11, Class 12, and NEET, as we are in the process of onboarding a highly qualified educator who meets our standards and vision.
        </p>
        <p className="placeholder-text">
        We appreciate your patience and dedication to learning. Meanwhile, we encourage you to explore other subjects and continue your academic journey with our existing tutorials.
        </p>
        <button className="go-back-btn" onClick={handleGoBack}>
        ← Back to Tutorial Page
        </button>
    </div>
  );
};

export default BiologyPlaceholder;
